let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aowYX")).then(() => parcelRequire('9koL4'));